import { LabelField, Text } from "components";
import React from "react";
import styled from "styled-components";
const styles = {
  body: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    flexWrap: "wrap",
    paddingTop: 10,
    flexGrow: 1,
    width: "100%",
  },
};
const RadioBody = styled.div`
  width: 46%;
  justify-content: start;
  align-items: center;
  display: flex;
  padding: 8px;
  cursor: pointer;
`;
export const RadioButton = ({
  title,
  card,
  defaultValue,
  style,
  error,
  type,
  list,
  labelStyle,
  elementStyle,
  field,
  name: fieldName,
  formik,
  onClick,
  boxValue,
  ...rest
}) => {
  return (
    <>
      {title ? <LabelField>{title}</LabelField> : null}
      <div
        className="input-group"
        style={{
          ...styles.body,
          ...style,
        }}
        name={fieldName}
      >
        {list.map(({ value, label, name, ..._rest }, index) => (
          <RadioBody
            key={index}
            style={{ marginInlineEnd: 10, ...elementStyle }}
          >
            <input
              className="form-check-input"
              type="radio"
              id={index + value}
              checked={
                value?.toString() ===
                (boxValue || formik?.values?.[fieldName]?.toString())
              }
              onClick={() => {
                onClick
                  ? onClick({
                      target: {
                        name: fieldName,
                        value: value?.toString(),
                      },
                    })
                  : formik.setFieldValue(fieldName, value?.toString());
              }}
              {..._rest}
              {...rest}
              onChange={(e) => {}}
            />
            <label className="form-check-label" htmlFor={index + value}>
              <Text style={{ fontSize: 15, ...labelStyle }}>
                {label || name}
              </Text>
              {name === "Card" && card !== null ? (
                <div>**** **** **** {card}</div>
              ) : (
                ""
              )}
            </label>
          </RadioBody>
        ))}
      </div>
    </>
  );
};
export default RadioButton;
